import React from 'react';

export const blockNonDigitKey = (e: React.KeyboardEvent<HTMLLabelElement>) => {
  if (e.ctrlKey || e.metaKey || e.altKey) {
    return;
  }
  if (e.key.length === 1 && !/\d/.test(e.key)) {
    e.preventDefault();
  }
};
